module.exports = __webpack_public_path__ + "img/日常检测select.720a70a0.svg";